import React from 'react';
import ReactDOM from 'react-dom';
import { SiteNav } from './components/SiteNav';

ReactDOM.render(<SiteNav />, document.getElementById('root'));
